import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchOfficialSentenceById } from "./officialSentenceService";
import "./OfficialSentenceListPage.css";

const levelColor = (l) => ({ EASY: "#4caf50", MEDIUM: "#ff9800", HARD: "#e91e63" }[l?.toUpperCase()] || "#999");

const OfficialSentenceDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sentence, setSentence] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      console.log("[OfficialSentenceDetailPage] Loading sentence id:", id);
      setLoading(true);
      const res = await fetchOfficialSentenceById(id);
      if (res.status === 200 && res.data?.status) {
        console.log("[OfficialSentenceDetailPage] Sentence loaded:", res.data.data?.title);
        setSentence(res.data.data);
      } else { console.error("[OfficialSentenceDetailPage] Load failed:", res.status, res.message); }
      setLoading(false);
    };
    load();
  }, [id]);

  if (loading) return (<><Navbar /><div className="osd-page"><p className="osd-loading">Loading...</p></div><Footer /></>);
  if (!sentence) return (<><Navbar /><div className="osd-page"><p className="osd-loading">Sentence not found.</p><button className="osd-back" onClick={() => navigate("/study/official-sentences")}>← Back</button></div><Footer /></>);

  return (
    <>
      <Navbar />
      <div className="osd-page">
        <button className="osd-back" onClick={() => navigate(sentence.categoryId ? `/study/official-sentences/category/${sentence.categoryId}` : "/study/official-sentences")}>
          ← Back to {sentence.categoryTitle || "Official Sentences"}
        </button>
        <div className="osd-hero">
          <div className="osd-tags">
            <span className="osd-category">{sentence.categoryTitle || sentence.categoryName}</span>
            <span className="osd-level" style={{ background: levelColor(sentence.level) }}>{sentence.levelDisplayName || sentence.level}</span>
          </div>
          <h1 className="osd-title">{sentence.title}</h1>
        </div>
        {sentence.pronunciation && (<div className="osd-card"><h3 className="osd-card-title">🗣️ Pronunciation</h3><p className="osd-pronunciation">{sentence.pronunciation}</p></div>)}
        {sentence.description && (<div className="osd-card"><h3 className="osd-card-title">📝 Meaning</h3><p className="osd-card-text">{sentence.description}</p></div>)}
        {sentence.createdAt && (<p className="osd-meta">Added on {new Date(sentence.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</p>)}
      </div>
      <Footer />
    </>
  );
};

export default OfficialSentenceDetailPage;
